import { render, staticRenderFns } from "./logisticsTab.vue?vue&type=template&id=8f1850ca&scoped=true&"
import script from "./logisticsTab.vue?vue&type=script&lang=js&"
export * from "./logisticsTab.vue?vue&type=script&lang=js&"
import style0 from "./logisticsTab.vue?vue&type=style&index=0&id=8f1850ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1850ca",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput,QSelect,QList,QExpansionItem,QSeparator,QIcon,QPopupProxy,QDate} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput,QSelect,QList,QExpansionItem,QSeparator,QIcon,QPopupProxy,QDate})
